import React from 'react'
import { Trans } from '@lingui/react'
import { gql } from 'graphql-tag'

import Dropdown from '../../layout/Dropdown'
import useAppState from '../../hooks/useAppState'
import PermissionWrapper from '../../util/PermissionWrapper'

const FRAGMENT = gql`
    fragment SettingsCoworkersActionsPopover on UnifiedPermissions {
        canDelete {
            isHidden
            reasonSlug
            value
        }
    }
`

const SettingsCoworkersActionsPopover = ({
    coworker,
    onUpdateCoworker,
    onRemoveCoworker,
    onResendCoworkerCrendentials,
    children,
}) => {
    const { currentUser } = useAppState()
    const currentUserIsCoworker = currentUser.id === coworker.id
    return (
        <Dropdown
            listItems={
                <Dropdown.List>
                    <Dropdown.HeaderListItem>
                        <Trans id="Actions" />
                    </Dropdown.HeaderListItem>
                    <Dropdown.ListItem
                        isSmaller
                        iconName="edit"
                        onClick={onUpdateCoworker}
                    >
                        <Trans id="Update coworker" />
                    </Dropdown.ListItem>
                    <PermissionWrapper
                        permission={coworker.permissions.canDelete}
                    >
                        <Dropdown.ListItem
                            isSmaller
                            iconName="delete"
                            onClick={onRemoveCoworker}
                            disabled={currentUserIsCoworker}
                        >
                            <Trans id="Delete coworker" />
                        </Dropdown.ListItem>
                    </PermissionWrapper>
                    <Dropdown.ListItem
                        isSmaller
                        iconName="outlook"
                        onClick={onResendCoworkerCrendentials}
                    >
                        <Trans id="Send credential info" />
                    </Dropdown.ListItem>
                </Dropdown.List>
            }
        >
            {children}
        </Dropdown>
    )
}

SettingsCoworkersActionsPopover.FRAGMENT = FRAGMENT

export default SettingsCoworkersActionsPopover
